export interface IUpdateMarketingProfile {
    DOB?: string;
    school?: string;
    year?: number;
    phone?: string;
    gender?: Gender;
    interests?: string[];
    accept_terms?: boolean;
}

export enum ProfileInterests {
    GAMING = 'GAMING',
    TECHNOLOGY = 'TECHNOLOGY',
    BUSINESS = 'BUSINESS',
    ART = 'ART',
    COOKING = 'COOKING',
    READING = 'READING',
    WRITING = 'WRITING',
    MUSIC = 'MUSIC',
    SPORTS = 'SPORTS',
    TRAVEL = 'TRAVEL',
    NATURE = 'NATURE',
    FASHION = 'FASHION',
    OTHER = 'OTHER',
}

export interface IProfileType {
    STUDENT: 'STUDENT';
    ADMIN: 'ADMIN';
    TEACHER: 'TEACHER';
    MENTOR: 'MENTOR';
    BUSINESS: 'BUSINESS';
    PUBLIC_FREE: 'PUBLIC_FREE';
    PUBLIC_NOT_PURCHASED: 'PUBLIC_NOT_PURCHASED';
    PUBLIC_PURCHASED: 'PUBLIC_PURCHASED';
    OTHER: 'OTHER';
}

export interface IMarketingProfile {
    id: string;
    user_id: number | null;
    first_name: string;
    last_name: string;
    email: string;
    profile_type: IProfileType;
    DOB: string;
    school: string;
    year: number;
    phone: number | undefined;
    gender: Gender | undefined;
    interests: string[];
    accept_terms: boolean;
    created_at: string;
    updated_at: string;
    deleted_at: string | undefined;
    is_deleted: boolean;
}

export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'OTHER',
}

export interface YearGroupOption {
    label: string;
    value: number;
}

export const YearGroups: YearGroupOption[] = [
    { label: 'Kindergarten', value: 1 },
    { label: 'Year 1', value: 1 },
    { label: 'Year 2', value: 2 },
    { label: 'Year 3', value: 3 },
    { label: 'Year 4', value: 4 },
    { label: 'Year 5', value: 5 },
    { label: 'Year 6', value: 6 },
    { label: 'Year 7', value: 7 },
    { label: 'Year 8', value: 8 },
    { label: 'Year 9', value: 9 },
    { label: 'Year 10', value: 10 },
    { label: 'Year 11', value: 11 },
    { label: 'Year 12', value: 12 },
];
